import { DiagnoseDetailPanelController } from './DiagnoseDetailPanelController';
import { Component, Renderer2 } from '@angular/core';
import { SlideLeft, SlideRight } from 'src/app/Util/AnimationUtil';
import { BasePanelSlide } from 'src/app/View/BaseUI/BasePanelSlide';
import { MatDialog } from '@angular/material/dialog';
import { GestureController } from '@ionic/angular';


/**
 * DiagnoseDetailPanelComponent
 * 検査結果PDF表示パネル
 */
@Component({
	selector: 'app-diagnose-detail-component',
	templateUrl: './DiagnoseDetailPanelComponent.html',
	styleUrls: ['./DiagnoseDetailPanelComponent.scss'],
	animations: [
		SlideLeft,
		SlideRight
	],
})
export class DiagnoseDetailPanelComponent extends BasePanelSlide {

	// 対となるコントローラー
	public combineCtrl: DiagnoseDetailPanelController;

	// 親から受け取るデータ
	public targetData: any;

	// PDFのソースデータ
	public pdfSrc: any;
	public zoom = 1;	// ズームの初期値
	public zoomScale = 'page-width';


	/**
	 * constructor
	 */
	constructor(public dialogCtrl: MatDialog, public render: Renderer2) {

		// Angulerのコンポーネントなので、上位を呼ぶ必要がある
		super();

		// コントローラーの生成
		this.createController(DiagnoseDetailPanelController);

	}

	/**
	 * 開始処理
	 */
	public async start() {

		// スワイプでロケーションバックを非活性にする
		this.disablePhoneSwipeBack();

		// スライドイン表示は自分でやる
		await this.slideIn();

		// PCR検査結果の場合は初期倍率を高くする
		if (this.targetData.name.startsWith('PCR')) {
			this.zoom = 1.5;
		}

		// 画面サイズによって縦横のどちらを合わせるか決定する
		this.setStylePdfZoomScale();

		// PDFデータ取得
		const ret = await this.execFuncWithErrorHandling(
			this,
			this.combineCtrl.getDiagnoseDetailData.bind(this),
			{ view: this, fileId: this.targetData.id }
		);
		if (!ret) {
			return;
		}
		this.pdfSrc = ret.uri;
	}

	////////////////////////////////
	// 画面イベント
	/**
	 * ズームが変更されたときのイベント
	 * @param zoom ズーム量
	 */
	public onClickChangeZoom(zoom: number) {

		// １桁台を切り捨て
		this.zoom = this.zoom + zoom;


	}

	/**
	 * PDFをダウンロードする
	 */
	public async onClickDownloadPDF() {

		// TODO: ファイル名変わらない

        // リンクを生成し、JavaScriptからクリック
        const objLink = document.createElement('a');
		objLink.href = this.pdfSrc;
		objLink.download = this.targetData.displayName + '.pdf';
		objLink.click();

		// オブジェクトを削除
		objLink.remove();
		URL.revokeObjectURL(this.pdfSrc);

	}

	// PDFファイルのプリントアウト
	public async onPrintPdf() {

		// TODO: 未実装

	}


	/**
	 * ズームスケールの初期値を変更し、表示を高さに合わせるか幅似合わせるかを設定する
	 */
	public setStylePdfZoomScale() {

		// 画面の縦横サイズを取得する
		const height = window.innerHeight;
		const width = window.innerWidth;

		// 幅より高さが大きい場合は、幅に合わせて表示する
		this.zoomScale = (height > width) ? 'page-width' : 'page-height';

	}




}



